import type { SettingsGroup } from '../../../../queries/skill-administration';
import { SettingsListRow } from '../settings-list';
import { SettingsSectionList } from '../settings-section-list';

export function TeamList({
  teams,
  title,
  onSelectTeam,
}: {
  teams: readonly SettingsGroup[];
  title: string;
  onSelectTeam: (team: SettingsGroup) => void;
}) {
  const rows = teams.map((team) => (
    <SettingsListRow
      key={team.uuid}
      title={team.name}
      description={team.description}
      onClick={() => onSelectTeam(team)}
      actionLabel={`Open details for ${team.name}`}
    />
  ));
  return (
    <SettingsSectionList title={title} emptyMessage={!teams.length ? 'No teams to display.' : undefined}>
      {teams.length ? rows : null}
    </SettingsSectionList>
  );
}
